<template>
  <div class="modal_sim_task">
    <div class="modal_sim_task__header">
      <h4 class="title">
        {{ translate("sim_task_modal.header") }}
      </h4>
    </div>

    <div class="modal_sim_task__body">
      <div class="line">
        <div class="input_wrap">
          <fg-input
              v-model="primary_data.title"
              type="text"
              :label="translate('sim_task_modal.title')"
              :placeholder="translate('sim_task_modal.title')"
          />
        </div>
      </div>

      <div class="line row">
        <div class="input_wrap col-md-8 col-sm-8">
          <label> {{ translate('sim_task_modal.action') }} </label>
          <tree-select
              v-model="primary_data.action"
              :options="action_list"
              :placeholder="translate('sim_task_modal.action')"
              :clearable="false"
              :searchable="false"
          />
        </div>
        <div class="input_wrap col-md-4 col-sm-4">
          <label> {{ translate('sim_task_modal.timeout') }} </label>
          <tree-select
              v-model="primary_data.timeout"
              :options="timeout_list"
              :placeholder="translate('sim_task_modal.timeout')"
              :clearable="false"
              :searchable="false"
              :max-height="200"
          />
        </div>
      </div>

      <div class="line">
        <div class="text_wrap">
          <div class="form-group">
            <label>{{ translate('sim_task_modal.iccids') }}</label>
            <textarea class="input_text" name="iccids" rows="10" v-model="primary_data.iccids" @paste="paste_iccids"/>
            <div>{{ translate('sim_task_modal.iccids_count', {count: iccids_count}) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_sim_task__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="create_sim_task"
      >
        {{ translate('btn.create') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>



export default {
  name: 'CreateSimTask',
  components: { },
  props: {
    simcards: {
      type: Array,
      default: () => []
    },
    iccid: {
      type: String,
      default: ''
    },
    sim_task_types: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      primary_data: {
        title: "",
        action: null,
        timeout: 24 * 3600,
        iccids: this.simcards.length > 0 ? this.simcards.map(item => item.iccid).filter(Boolean).join('\n') : this.iccid,
        source_type: "manual_ui"
      }
    }
  },
  created () {
    if (this.iccid) {
      this.primary_data.title = this.translate('sim_task_modal.title_for_iccid', {iccid: this.iccid})
    }
  },
  computed:{
    iccids_count(){
      return this.primary_data.iccids.split(/[,\r\n]+/).filter(item => item.trim() !== '').length
    },
    timeout_list(){
      return Array.from({length: 24}, (_, index) => {
        let hours = index + 1
        return {id: hours * 3600, label: this.translate('sim_task_modal.timeout_hours', {hours})}
      })
    },
    action_list(){
      const actions = this.sim_task_types ?? this.$store.getters.getSimTasks.actions
      return actions.map(item => {
        return {id: item.code ?? item.id, label: item.name ?? item.descr}
      })
    },
  },

  methods: {
    paste_iccids(event){
      const text = event.clipboardData?.getData('text/plain')
      if (!text || !text.trim()) return
      event.preventDefault()
      const textarea = event.target
      const before = textarea.value.slice(0, textarea.selectionStart)
      const after = textarea.value.slice(textarea.selectionEnd)
      const iccids = text.split(/[,\r\n]+/).map(item => item.trim()).filter(Boolean).join('\n')
      const separator = before && !/[,\r\n]$/.test(before) ? '\n' : ''
      const inserted = separator + iccids + (after.startsWith('\n') ? '' : '\n')
      this.primary_data.iccids = before + inserted + after
      this.$nextTick(() => {
        const position = before.length + inserted.length + (after.startsWith('\n') ? 1 : 0)
        textarea.setSelectionRange(position, position)
      })
    },
    create_sim_task(){
      this.$http.simcard.createSimTask(this.primary_data, (response) => {
        this.global_notify('info', this.translate('sim_task_modal.created_success'))
        this.$emit('update')
      })
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_sim_task{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;

      .line{
        margin-bottom: 10px;
      }
      .input_wrap{
        text-align: start;
        margin-bottom: 10px;
      }
      .text_wrap{
        text-align: start;
      }
    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
